import { Search, FileText, MessageSquare, BookOpen, Clock, Database } from "lucide-react"

export function KeyFeatures() {
  const features = [
    {
      title: "Minnesota-Specific",
      description: "Access compliance guidance tailored specifically to Minnesota state regulations and requirements.",
      icon: <Search className="h-8 w-8 text-primary dark:text-primary-light" />,
    },
    {
      title: "Source Citations",
      description: "Every answer includes citations to relevant Minnesota statutes and official documentation.",
      icon: <FileText className="h-8 w-8 text-primary dark:text-primary-light" />,
    },
    {
      title: "Natural Language",
      description: "Ask questions in plain English — no need for legal terminology or complex phrasing.",
      icon: <MessageSquare className="h-8 w-8 text-primary dark:text-primary-light" />,
    },
    {
      title: "Regulatory Coverage",
      description: "Comprehensive guidance on 245D, Home Care, 144G, and other Minnesota healthcare regulations.",
      icon: <BookOpen className="h-8 w-8 text-primary dark:text-primary-light" />,
    },
    {
      title: "Time-Saving",
      description: "Get answers in seconds instead of spending hours researching regulatory requirements.",
      icon: <Clock className="h-8 w-8 text-primary dark:text-primary-light" />,
    },
    {
      title: "Trusted Sources",
      description: "All information comes directly from official Minnesota government documentation.",
      icon: <Database className="h-8 w-8 text-primary dark:text-primary-light" />,
    },
  ]

  return (
    <section id="features" className="relative py-24 md:py-32 bg-gradient-to-b from-gray-50 to-white dark:from-[#1E293B] dark:to-[#0F172A] overflow-hidden scroll-mt-20">

      
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Gradient orbs */}
        <div className="absolute top-1/4 -left-20 w-60 h-60 bg-primary/10 dark:bg-primary/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-0 w-80 h-80 bg-primary-light/10 dark:bg-primary-light/20 rounded-full blur-3xl"></div>
        
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-grid-gray-500/[0.03] dark:bg-grid-gray-400/[0.05] bg-[length:30px_30px]"></div>
      </div>

      <div className="container px-4 md:px-8 lg:px-12 mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in">
          <div className="inline-flex items-center px-4 py-1 rounded-full text-sm font-medium bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary-light mb-4 backdrop-blur-sm">
            KEY FEATURES
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground dark:text-white mb-6 tracking-tight">
            Everything You <span className="text-primary dark:text-primary-light">Need</span>
          </h2>
          <p className="text-xl text-muted-foreground dark:text-gray-300 max-w-2xl mx-auto">
            CareAdvisor provides authoritative guidance on Minnesota compliance questions with references to official sources.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="group relative"
            >
              {/* Hover glow effect */}
              <div className="absolute -inset-px rounded-xl bg-gradient-to-r from-primary/20 to-primary-light/20 dark:from-primary/30 dark:to-primary-light/30 opacity-0 group-hover:opacity-100 transition-all duration-300 blur-md"></div>
              
              <div className="relative bg-white dark:bg-[#1E293B] rounded-xl p-6 shadow-xl border border-gray-100 dark:border-gray-800/50 transition-all duration-300 group-hover:-translate-y-1 h-full">
                <div className="h-14 w-14 rounded-2xl bg-primary/10 dark:bg-primary/20 flex items-center justify-center mb-5">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-foreground dark:text-white mb-3">{feature.title}</h3>
                <p className="text-muted-foreground dark:text-gray-300">{feature.description}</p>
                
                {/* Bottom accent line */}
                <div className="h-1 w-10 bg-gradient-to-r from-primary to-primary-light rounded-full mt-5 transition-all duration-300 group-hover:w-16"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  )
} 